import {getLang} from '../../../Localization';

export const getKeyByLang = (formName: string, categoryName: string, fieldName: string) => {
    const lang = getLang();
    return `${formName}:${categoryName}:${lang}:${fieldName}`;
};
